import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';

function productCell(visibleColumns: any) {
  if (!visibleColumns.includes('products')) {
    return null;
  }
  return {
    title: <TableHeader title={getI18n().t('Product', { ns: 'sales' })} />,
    dataIndex: ['products'],
    key: 'products',
    render: (products: any) => {
      if (!products || typeof products !== 'object') {
        return <CellText>-</CellText>;
      }

      // Normalise: merge 'NGenius Online', 'ngeniusOnline', 'ecom' → 'ECOM'; drop old keys
      const normalised: Record<string, boolean> = {
        'ECOM': !!(products['ECOM'] || products['ecom'] || products['NGenius Online'] || products['ngeniusOnline']),
        'Pay Links': !!(products['Pay Links'] || products['payLinks']),
        'POS': !!(products['POS'] || products['pos']),
        'Other': !!(products['Other'] || products['other']),
      };

      const activeProducts = Object.entries(normalised)
        .filter(([_, value]) => value === true)
        .map(([key]) => key);

      return <CellText>{activeProducts.length > 0 ? activeProducts.join(', ') : '-'}</CellText>;
    },
    width: 150,
  };
}

export default productCell;
